import React from "react";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { get, map, max, min, filter } from "lodash";

import {
  Map,
  CircleMarker,
  TileLayer,
  Tooltip,
  ZoomControl,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";

import DashboardCard from "../DashboardCard";

import colors from "../../../assets/style/colors";
import { sizes } from "../../../constants/common";

const styles = {
  map: {
    "& .leaflet-tile-pane": {
      webkitFilter: "grayscale(100%)",
      filter: "grayscale(100%)",
    },
  },
  tooltip: {
    backgroundColor: colors.white,
    borderRadius: "2px",
    padding: "5px 10px !important",
  },
  tooltipTitle: {
    color: colors.black87,
    fontWeight: "bold",
    marginBottom: "10px",
  },
  tooltipInfo: {
    margin: "3px 0px 3px 5px",
  },
  tooltipLabel: {
    color: colors.black87,
  },
  tooltipValue: {
    color: colors.black54,
  },
};

const center = {
  lat: 45.950401,
  long: -75.688803,
};

const MdcMap = (props) => {
  const { classes, data } = props;

  const maxLat = max(
    map(get(data, ["card5"]), (d) => get(d, ["coordinates", 0]))
  );
  const minLat = min(
    map(get(data, ["card5"]), (d) => get(d, ["coordinates", 0]))
  );
  const maxLong = max(
    map(get(data, ["card5"]), (d) => get(d, ["coordinates", 1]))
  );
  const minLong = min(
    map(get(data, ["card5"]), (d) => get(d, ["coordinates", 1]))
  );

  const bufferLat = (maxLat - minLat) * 0.05;
  const bufferLong = (maxLong - minLong) * 0.15;

  return (
    <DashboardCard title={I18n.get("dashboard_onSites")} size={sizes.medium}>
      <Map
        style={{ height: "410px", width: "100%", zIndex: 1 }}
        zoom={1}
        zoomControl={false}
        center={[center.lat, center.long]}
        bounds={
          data && !isNaN(bufferLat) && !isNaN(bufferLong)
            ? [
                [minLat - bufferLat, minLong - bufferLong],
                [maxLat + bufferLat, maxLong + bufferLong],
              ]
            : null
        }
        className={classes.map}
      >
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {map(
          filter(
            get(data, ["card5"]),
            (site) =>
              get(site, ["coordinates", 0]) && get(site, ["coordinates", 1])
          ),
          (site, index) => (
            <CircleMarker
              key={index}
              center={[
                get(site, ["coordinates", 0]),
                get(site, ["coordinates", 1]),
              ]}
              radius={max([20 * Math.log(get(data, ["card5"]) / 5), 10])}
              fillOpacity={0.8}
              fillColor={colors.primary}
              stroke={false}
            >
              <Tooltip
                direction="top"
                offset={[0, 0]}
                opacity={1}
                className={classes.tooltip}
              >
                <div className={classes.tooltipTitle}>
                  {get(site, ["name"])}
                </div>
                <div className={classes.tooltipInfo}>
                  <span className={classes.tooltipLabel}>
                    {I18n.get("dashboard_trucks")}
                    {": "}
                  </span>
                  <span className={classes.tooltipValue}>
                    {get(site, ["trucks"])}
                  </span>
                </div>
                <div className={classes.tooltipInfo}>
                  <span className={classes.tooltipLabel}>
                    {I18n.get("dashboard_trailersContainers")}
                    {": "}
                  </span>
                  <span className={classes.tooltipValue}>
                    {get(site, ["trailers_containers"])}
                  </span>
                </div>
                <div className={classes.tooltipInfo}>
                  <span className={classes.tooltipLabel}>
                    {I18n.get("dashboard_privateVehicles")}
                    {": "}
                  </span>
                  <span className={classes.tooltipValue}>
                    {get(site, ["private_vehicle"])}
                  </span>
                </div>
              </Tooltip>
            </CircleMarker>
          )
        )}
        <ZoomControl position="bottomright" />
      </Map>
    </DashboardCard>
  );
};

export default withStyles(styles)(MdcMap);
